import { Directive, ElementRef, AfterViewInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[checkImpersonator]'
})
export class ImpersonatorPermissionDirective implements AfterViewInit, OnChanges {

    @Input() checkImpersonator: boolean;
    @Input() property: boolean;

    constructor(private el: ElementRef) {
    }

    ngAfterViewInit() {
        this.checkPermission();
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.checkImpersonator) {
            this.checkPermission();
        }
    }

    private checkPermission() {
        const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
        const isDisabled = impersonator && impersonator.id ? true : false;
        this.el.nativeElement.disabled = isDisabled || this.checkImpersonator;
    }
}
